/* eslint-disable grouped-accessor-pairs */
/* eslint-disable array-callback-return */
/* eslint-disable consistent-return */
import {
  RouteResponse,
  StationResponse,
  WardResponse,
  IndustryLResponse,
  IndustrySResponse,
  JobTypeLResponse,
  JobTypeMResponse,
  JobTypeSResponse,
  QualificationResponse,
  AreaResponse,
  RailwayCompanyResponse,
  Jp_doda_hydrogen_presentation_v2_response_IndustryLargeResponse,
} from '@doda/api-client/aspida/@types';

export interface CityOfSearchModal {
  id: string;
  name: string;
  prefId: string;
  isOrdinanceDesignatedCity: boolean;
  wardList: WardResponse[];
}

export interface PrefOfSearchModal {
  id: string;
  name: string;
}

export interface AreaListOfSearchModal {
  id: string;
  name: string;
  prefectureList: PrefOfSearchModal[];
}

export interface RouteOfSearchModal extends RouteResponse {
  prefIdList: string[];
}
export interface CompanyOfSearchModal {
  id: string;
  name: string;
  routeList: RouteOfSearchModal[];
  prefIdList: string[];
}

export interface RouteWithCompany extends RouteOfSearchModal {
  companyName: string;
}
export interface QualificationData {
  categoryId: string;
  qualificationName: string;
  ranks: NonNullable<QualificationResponse['qualifications']>[number]['ranks'];
}
export type QualificationMap = Map<string, QualificationData>;

export class MasterCacheModel {
  _industry: IndustryLResponse[] | null = null;

  _industryV2:
    | Jp_doda_hydrogen_presentation_v2_response_IndustryLargeResponse[]
    | null = null;

  _occupation: JobTypeLResponse[] | null = null;

  _area: AreaListOfSearchModal[] | null = null;

  // TODO PCの検索サイドバー用に追加したが_area, _cityとデータ内容が被っているため要統合
  _areaFullData: AreaResponse[] | null = null;

  _city: CityOfSearchModal[] | null = null;

  _route: CompanyOfSearchModal[] | null = null;

  // TODO PCの検索サイドバー用に追加したが_routeとデータ内容が被っているため要統合
  _routeFullData: RailwayCompanyResponse[] | null = null;

  _qualification: QualificationResponse[] | null = null;

  qualificationMap: QualificationMap = new Map();

  set industry(data: typeof this._industry) {
    this._industry = data;
  }

  set industryV2(data: typeof this._industryV2) {
    this._industryV2 = data;
  }

  set occupation(data: typeof this._occupation) {
    this._occupation = data;
  }

  set area(data: typeof this._area) {
    this._area = data;
  }

  set areaFullData(data: typeof this._areaFullData) {
    this._areaFullData = data;
  }

  set city(data: typeof this._city) {
    this._city = data;
  }

  set route(data: typeof this._route) {
    this._route = data;
  }

  set routeFullData(data: typeof this._routeFullData) {
    this._routeFullData = data;
  }

  set qualification(data: typeof this._qualification) {
    this._qualification = data;
  }

  get industry() {
    return this._industry;
  }

  get industryV2() {
    return this._industryV2;
  }

  get occupation() {
    return this._occupation;
  }

  get area() {
    return this._area;
  }

  get areaFullData() {
    return this._areaFullData;
  }

  get city() {
    return this._city;
  }

  get route() {
    return this._route;
  }

  get routeFullData() {
    return this._routeFullData;
  }

  get qualification() {
    return this._qualification;
  }

  findIndustry(id: string) {
    let item: IndustryLResponse | IndustrySResponse | undefined;
    this.industry?.some((i) => {
      if (i.id === id) {
        item = i;
        return true;
      }
      return i.industrySList.some((m) => {
        if (m.id === id) {
          item = m;
          return true;
        }
      });
    });
    return item;
  }

  findOccupation(id: string) {
    let item:
      | JobTypeLResponse
      | JobTypeMResponse
      | JobTypeSResponse
      | undefined;
    this.occupation?.some((i) => {
      if (i.searchJobTypeId === id) {
        item = i;
        return true;
      }
      return i.jobTypeMList.some((m) => {
        if (m.searchJobTypeId === id) {
          item = m;
          return true;
        }
        return m.jobTypeSList.some((s) => {
          if (s.searchJobTypeId === id) {
            item = s;
          }
          return item;
        });
      });
    });
    return item;
  }

  /** 新職種分類IDから検索用職種分類IDを探す */
  findSearchJobTypeIdFromId(id: string) {
    if (!this.occupation) return;
    // 大分類
    if (id.length === 2) {
      return this.occupation.find((jobL) => jobL.id === id)?.searchJobTypeId;
    }
    // 中分類
    if (id.length === 4) {
      const idL = id.substring(0, 2);
      const matchedJobL = this.occupation.find((jobL) => jobL.id === idL);
      if (!matchedJobL) return;
      return matchedJobL.jobTypeMList.find((jobM) => jobM.id === id)
        ?.searchJobTypeId;
    }
    // 小分類
    if (id.length === 6) {
      const idL = id.substring(0, 2);
      const idM = id.substring(0, 4);
      const matchedjobL = this.occupation.find((jobL) => jobL.id === idL);
      if (!matchedjobL) return;
      const matchedJobM = matchedjobL.jobTypeMList.find(
        (jobM) => jobM.id === idM
      );
      if (!matchedJobM) return;
      return matchedJobM.jobTypeSList.find((jobS) => jobS.id === id)
        ?.searchJobTypeId;
    }
  }

  findArea(id: string) {
    return this.area?.find((i) => i.id === id);
  }

  findPrefecture(id: string) {
    let item: PrefOfSearchModal | undefined;
    this.area?.some((a) => {
      return a.prefectureList.some((r) => {
        if (r.id === id) item = r;
        return item;
      });
    });
    return item;
  }

  findCity(id: string) {
    return this.city?.find((i) => i.id === id);
  }

  findWard(id: string) {
    let item: WardResponse | undefined;
    this.city?.some((a) => {
      return a.wardList.some((r) => {
        if (r.id === id) item = r;
        return item;
      });
    });
    return item;
  }

  findRoute(id: string) {
    let item: RouteOfSearchModal | undefined;
    this.route?.some((i) => {
      return i.routeList.some((r) => {
        if (r.id === id) item = r;
        return item;
      });
    });
    return item;
  }

  findStation(id: string) {
    let item: StationResponse | undefined;
    this.route?.some((i) => {
      return i.routeList.some((m) => {
        return m.stationList.some((s) => {
          if (s.id === id) {
            item = s;
          }
          return item;
        });
      });
    });
    return item;
  }

  getRouteWithCompany(id: string) {
    let item: RouteWithCompany | undefined;
    this.route?.some((i) => {
      return i.routeList.some((r) => {
        if (r.id === id) item = { ...r, companyName: i.name };
        return item;
      });
    });
    return item;
  }

  getStationWithPref(id: string) {
    let item: (StationResponse & { prefName: string }) | undefined;
    this.route?.some((i) => {
      return i.routeList.some((m) => {
        return m.stationList.some((s) => {
          if (s.id === id) {
            const pref = this.findPrefecture(s.prefectureId);
            item = { ...s, prefName: pref?.name ?? '' };
          }
          return item;
        });
      });
    });
    return item;
  }

  getWardWithPref(id: string) {
    let item: (WardResponse & { prefName: string }) | undefined;
    this.city?.some((a) => {
      return a.wardList.some((r) => {
        if (r.id === id) {
          const pref = this.findPrefecture(a.prefId);
          item = { ...r, prefName: pref?.name ?? '' };
        }
        return item;
      });
    });
    return item;
  }

  getCityWithPref(id: string) {
    const city = this.findCity(id);
    if (city) {
      const pref = this.findPrefecture(city.prefId);
      return { ...city, prefName: pref?.name ?? '' };
    }
    return undefined;
  }

  hasQualification(id: string) {
    return this.qualificationMap.has(id);
  }

  findQualification(id: string) {
    return this.qualificationMap.get(id);
  }
}

export default new MasterCacheModel();
